<template>
  <div>
    <div>
      <i class="fas fa-fire text-warning-red text-md"></i>
      <span
        class="text-sm ml-1"
      >An item in your cart is in high demand. Don't worry though, we'll reserve it for you.</span>
    </div>
    <div
      class="text-md font-semibold border border-smurfs-gold bg-smurfs-gold-50 rounded py-1 px-4 mt-4"
    >
      {{ timerString }}
    </div>
  </div>
</template>

<script>
import { reservationTimerMixin } from '../../shared/mixins/reservationTimerMixin';

export default {
  mixins: [reservationTimerMixin],
};
</script>
